import {ref} from 'vue';

export default {
    install: (app, options) => {
        const countries = ref([]);
        const salesRegionsCountries = ref([]);
        const geographicRegionsCountries = ref([]);

        const loadCountries = (urlParameters) => {
            const defaultUrlParameters = {
                all: true,
                category: '',
                from: '',
                with: '',
            };

            urlParameters = Object.assign(defaultUrlParameters, urlParameters)

            const urlSearchParams = new URLSearchParams(urlParameters);

            window.lazy_axios.get(`/countries/?${urlSearchParams.toString()}`)
                .then((response) => {
                    if (response.data.countries && response.data.countries.data) {
                        switch (urlParameters.category) {
                            case 'sales-regions':
                                salesRegionsCountries.value = response.data.countries.data;
                                break;

                            case 'geographic-regions':
                                geographicRegionsCountries.value = response.data.countries.data;
                                break;

                            default:
                                countries.value = response.data.countries.data;
                                break;
                        }
                    }
                });
        };

        app.provide('countries', countries);
        app.provide('countries.sales_regions', salesRegionsCountries);
        app.provide('countries.geographic_regions', geographicRegionsCountries);
        app.provide('loadCountries', loadCountries);
    },
}
